import { render, staticRenderFns } from "./UserSelectField.vue?vue&type=template&id=03bf9d24&scoped=true"
import script from "./UserSelectField.vue?vue&type=script&lang=js"
export * from "./UserSelectField.vue?vue&type=script&lang=js"
import style0 from "./UserSelectField.vue?vue&type=style&index=0&id=03bf9d24&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03bf9d24",
  null
  
)

export default component.exports